/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC } from 'react'
import { UserCard } from '../modules/users'

const UserPage: FC = () => (
  <>
    {/* begin::Row */}
    <div className='row gy-5 g-xl-12'>
      <div className='col-xxl-12'>
        <UserCard />
      </div>
    </div>
    {/* end::Row */}
  </>
)

const UserWrapper: FC = () => {
  return (
    <>
      <UserPage />
    </>
  )
}

export { UserWrapper }
